// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sunbit-badge[data-v-8b25405a]{font-size:clamp(10px,1vw,11px)}.sunbit-logo[data-v-8b25405a]{height:clamp(12px,1.5vw,15px);width:auto}.badge[data-v-8b25405a]{font-size:clamp(.75rem,1vw,.85rem);white-space:nowrap}.status-text[data-v-8b25405a]{font-size:clamp(10px,1vw,11px)}@media (max-width:576px){.sunbit-badge[data-v-8b25405a]{margin-left:0;margin-top:.5rem}}", ""]);
// Exports
module.exports = exports;
